import { render, staticRenderFns } from "./major.vue?vue&type=template&id=e63ba21e&scoped=true"
import script from "./major.vue?vue&type=script&lang=js"
export * from "./major.vue?vue&type=script&lang=js"
import style0 from "./major.vue?vue&type=style&index=0&id=e63ba21e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63ba21e",
  null
  
)

export default component.exports